import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import AdminConsole from './pages/AdminConsole';
import Login from './pages/Login';
import ReleasesList from './pages/ReleasesList';
import ReleaseDetail from './pages/ReleaseDetail';
import ArtistsList from './pages/ArtistsList';
import ArtistDetail from './pages/ArtistDetail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminConsole />} />
        <Route path="/login" element={<Login />} />
        <Route path="/releases" element={<ReleasesList />} />
        <Route path="/releases/:id" element={<ReleaseDetail />} />
        <Route path="/artists" element={<ArtistsList />} />
        <Route path="/artists/:id" element={<ArtistDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
